import { render, staticRenderFns } from "./OpenDropdown.vue?vue&type=template&id=1383d316"
import script from "./OpenDropdown.vue?vue&type=script&lang=js"
export * from "./OpenDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports